export const CreateScreenCaptureDevice = async () => {
	const supported = navigator.mediaDevices.getSupportedConstraints();
	console.info("[CreateScreenCaptureDevice] supported", JSON.stringify(supported));
	const stream = await navigator.mediaDevices.getDisplayMedia({
		audio: true,
		video: {
			width: 2080,
			height: 720,
			frameRate: 24
		}
	} as any);

	console.info("[CreateScreenCaptureDevice] getCapabilities", JSON.stringify(stream.getVideoTracks()[0].getCapabilities()));
	console.info("[CreateScreenCaptureDevice] getConstraints", JSON.stringify(stream.getVideoTracks()[0].getConstraints()));

	return stream;
}